import { render, staticRenderFns } from "./IconArrowheadDown.vue?vue&type=template&id=2e4df62f&"
import script from "./IconArrowheadDown.vue?vue&type=script&lang=js&"
export * from "./IconArrowheadDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports